import React from 'react'
import { Tag } from 'antd'
import { orders as vocabulary, translator } from '../../../../i18n/ru'

const STATUS_COLOR_MAP: Record<string, string> = {
  new: '#2db7f5',
  completed: '#87d068',
  cancelled: '#1806ba',
  failed: '#f50',
  unresolved: '#f50ae5',
  refunded: '#f7950c',
}
type Props = {
  status: string
}
const translate = translator(vocabulary)

export const Status: React.FunctionComponent<Props> = ({ status }) => {
  return <Tag color={STATUS_COLOR_MAP[status]}>{translate(status)}</Tag>
}
